import LandingTextHoverImage from '../../../../components/_external-pages/landing/LandingTextHoverImage';

export const AboutTextHoverImage = () => {
  return (
    <LandingTextHoverImage
      image={'static/about/hero2.webp'}
      text={
        '"Estamos comprometidos en crear una nueva experiencia en servicios financieros para las familias. Buscamos que las familias tengan acceso a crédito ágil y herramientas que impulsarán su bienestar"'
      }
      minimalText={'Glennys Rosario – CEO iBAN Online'}
    />
  );
};
